import React from 'react';
import { Outlet } from 'react-router-dom';
export default function IndexLayoutMobile() {

    return (
        <div style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
            <Outlet />
        </div>
    );
}
